import Glide from '@glidejs/glide';

document.addEventListener("DOMContentLoaded", () => {

  if (document.querySelector('.glide-print-resources')) {
    let glideEndorsements = new Glide('.glide-print-resources', {
      type: 'carousel',
      perView: 2,
      focusAt: 'center',
      animationDuration: 800,
      gap: 40,

    });
    glideEndorsements.mount();
  }

  if (document.querySelector('.glide-digital-endorsements')) {
    let glideDigitalEndorsements = new Glide('.glide-digital-endorsements', {
      type: 'carousel',
      perView: 1,
      focusAt: 'center'
    });
    glideDigitalEndorsements.mount();
  }

  if (document.querySelector('.glide-event-endorsements')) {
    let glideEventEndorsements = new Glide('.glide-event-endorsements', {
      type: 'carousel',
      perView: 1,
      focusAt: 'center'
    });
    glideEventEndorsements.mount();
  }

  if (document.querySelector('.glide-social-endorsements')) {
    let glideSocialEndorsements = new Glide('.glide-social-endorsements', {
      type: 'carousel',
      perView: 1,
      focusAt: 'center'
    });
    glideSocialEndorsements.mount();
  }

});